import { render } from "./WordClipper.vue?vue&type=template&id=639764c0&scoped=true"
import script from "./WordClipper.vue?vue&type=script&lang=js"
export * from "./WordClipper.vue?vue&type=script&lang=js"

import "./WordClipper.vue?vue&type=style&index=0&id=639764c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-639764c0"]])

export default __exports__